import { API_BASE_URL } from '../config';

export const getSearchesPageContent = async (lang = "en") => {
    try {
      const response = await fetch(
        `${API_BASE_URL}custom_pages?lang=${lang}`
      );
      if (!response.ok) {
        throw new Error(`Error: ${response.status}`);
      }
      const data = await response.json();
      return data;
    } catch (err) {
      throw new Error(err.message);
    }
  };